import { Controller, TextAreaController } from '@organisms';
import { Col, Form, Row } from 'antd';
import { useMemo } from 'react';
import { Controller as ControllerHookForm, useWatch } from 'react-hook-form';

import { toFieldStatus } from 'src/app/utils/toFieldStatus';
import { SettingsConfigType } from 'src/features/tenants/types/tenantForm.types';

import { configTypeComponetsByType } from './ConfigTypeComponents';

export interface SettingsBodyProps {
  name: 'settings.edit' | 'settings.add';
  index: number;
  control: any;
}

export function SettingsBody({ index, name, control }: SettingsBodyProps) {
  const settings = useWatch({ name: `${name}` });

  const ValueInput = useMemo(() => {
    const settigstype = settings[index].configType as
      | SettingsConfigType
      | undefined;
    return configTypeComponetsByType[settigstype ?? SettingsConfigType.String];
  }, [settings]);

  return (
    <Row
      gutter={16}
      style={{ width: '100%', marginBlockEnd: 18, paddingRight: 68 }}
    >
      <Col span={12}>
        <Controller
          label='Chave'
          id={`configKey-${name}-${index}`}
          name={`${name}.${index}.configKey`}
          placeholder='Insira o nome da chave...'
          control={control}
          required
          allowClear
        />
      </Col>
      <Col span={12}>
        <ControllerHookForm
          control={control}
          name={`${name}.${index}.configValue`}
          render={({ field, fieldState }) => {
            const { status, help } = toFieldStatus(fieldState.error);
            return (
              <Form.Item
                required
                validateStatus={status}
                help={help}
                label='Valor'
              >
                <ValueInput field={field} />
              </Form.Item>
            );
          }}
        />
      </Col>
      <Col span={24}>
        <TextAreaController
          row={3}
          id={`configKeyDescription-${name}-${index}`}
          label='Descrição'
          name={`${name}.${index}.configKeyDescription`}
          placeholder='Descreva aqui...'
          control={control}
          required
        />
      </Col>
    </Row>
  );
}
